import { createContext, useContext, useMemo, useState } from "react";

export type SearchExpandedContextValue = {
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
};

const Ctx = createContext<null | SearchExpandedContextValue>(null);

export function useSearchExpanded(): SearchExpandedContextValue {
  const ctx = useContext(Ctx);

  if (!ctx)
    throw new Error(
      "useSearchExpanded must be used within SearchExpandedProvider",
    );

  return ctx;
}

export function SearchExpandedProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const value = useMemo(() => ({ isExpanded, setIsExpanded }), [isExpanded]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
